import * as React from 'react';
import {UncontrolledTooltip} from 'reactstrap';
import DateTimeFormatter from '../../../helpers/DateTimeFormatter';
import {onCarrierLogoError} from '../../../helpers/CarrierLogoFallback';
import TransportHelper, {TRANSPORT_TRAIN} from '../../../helpers/TransportHelper';
import {TransportIcon} from '../../common/SegmentTransport';
const BACK = 'back';

const FlightSector = (props) => {
    if (!props.sector) {
        return null;
    }

    const durationHours = DateTimeFormatter.secsToTimeParts(props.sector.duration)[0];
    const durationMinutes = DateTimeFormatter.secsToTimeParts(props.sector.duration)[1];

    let isDirect = (direction) => {
        if (direction === BACK) {
            return props.flight.returnSector.stops === 0;
        }

        return props.flight.forwardSector.stops === 0;
    };

    let renderSectorStops = (sector, direction) => {
        if (isDirect(direction)) {
            return props.translator.trans('Direct');
        } else if (props.sector.stops === 1) {
            return props.sector.stops + ' ' + props.translator.trans('stop');
        } else {
            return props.sector.stops + ' ' + props.translator.trans('stops');
        }
    };

    const durationText = DateTimeFormatter.timeFormat(durationHours, durationMinutes, props.translator.trans('h.'), props.translator.trans('m.'));
    const carrier = props.segments && props.segments[0] ? props.segments[0] : null;
    const arrivalDayOffset = DateTimeFormatter.dayOffset(props.sector.departureTime, props.sector.arrivalTime);
    const dayOffsetId = `fs-dayoffset-${props.index}-${props.direction}`;
    const transports = TransportHelper.getSegmentsTransports(props.segments);

    return (
        <div className={`${props.direction === BACK ? 'return' : ''}`}>
            {/* Leg row (all breakpoints) — design anatomy: tile > departure > duration+line+stops > arrival > date */}
            <div className="ff-leg" onClick={props.toggleCollapse}>
                <span className="ff-plane-tile">
                    {carrier &&
                        <img
                            className="ff-plane-tile__logo"
                            src={`/assets/cdn/flights/carriers/xsmall/${carrier.carrier}.png`}
                            alt={carrier.carrierName}
                            onError={onCarrierLogoError}
                        />
                    }
                </span>
                <div className="ff-leg__point">
                    <div className="ff-leg__time num">{DateTimeFormatter.getTime(props.sector.departureTime)}</div>
                    <div className="ff-leg__code">{props.sector.departureAirport}</div>
                </div>
                <div className="ff-leg__mid">
                    <div className="ff-leg__dur num">{durationText}</div>
                    <div className="ff-leg__line"><span className="ff-leg__dot ff-leg__dot--start"/><span className="ff-leg__dot ff-leg__dot--end"/></div>
                    <div className={`ff-leg__stops ${isDirect(props.direction) ? 'is-direct' : 'is-stops'}`}>
                        {renderSectorStops(props.sector, props.direction)}
                    </div>
                    {transports.map((transport) => (
                        <div key={transport} className={`ff-leg__transport ff-leg__transport--${transport}`}
                             style={{display: 'inline-flex', alignItems: 'center', gap: '4px', fontSize: '12px', fontWeight: 600}}>
                            <TransportIcon transport={transport}/>
                            {props.translator.trans(transport === TRANSPORT_TRAIN ? 'Includes train' : 'Includes bus')}
                        </div>
                    ))}
                </div>
                <div className="ff-leg__point">
                    <div className="ff-leg__time num">
                        {DateTimeFormatter.getTime(props.sector.arrivalTime)}
                        {arrivalDayOffset > 0 &&
                            <React.Fragment>
                                <sup className="ff-leg__dayoffset" id={dayOffsetId}>+{arrivalDayOffset}</sup>
                                <UncontrolledTooltip delay={0} fade={false} placement="top" target={dayOffsetId}>
                                    {arrivalDayOffset === 1
                                        ? props.translator.trans('Arrives the next day')
                                        : props.translator.trans('Arrives [count] days later').replace('[count]', arrivalDayOffset)}
                                </UncontrolledTooltip>
                            </React.Fragment>
                        }
                    </div>
                    <div className="ff-leg__code">{props.sector.arrivalAirport}</div>
                </div>
                <div className="ff-leg__date num">{DateTimeFormatter.getDate(props.sector.departureTime, props.dateFormat)}</div>
            </div>
        </div>
    );
};

export default FlightSector;



// WEBPACK FOOTER //
// ./src/components/flights/FlightCard/FlightSector.js